import axios from "axios";
import { LOGIN } from "../constantes";
export const POST_LOGIN = 'POST_LOGIN';
export const SET_USER = "SET_USER";
export const LOGOUT = "LOGOUT";

axios.defaults.withCredentials = true;
export const postLogin = (payload) => async dispatch => {
    //console.log(payload);
    
    try {                  
        await axios.post(`${LOGIN}/login`, payload, {withCredentials: true})
        .then(res => {
            const userData = res.data
            //console.log('Response ID:', userData.id);
            //console.log('Response isAuthenticated:', true);        
            
            localStorage.setItem('userId', userData.id)
            localStorage.setItem('isAuthenticated', true)
            localStorage.setItem('userData', JSON.stringify(userData))
            
            // sessionStorage.setItem('userId', userData.id)                   //al guardar en la sesion, una vez se cierre la pestañana, ventana o navegador se piden nuevamente las credenciales
            // sessionStorage.setItem('isAuthenticated', true)
            // sessionStorage.setItem('userData', JSON.stringify(userData))


            dispatch({
                type: POST_LOGIN,
                payload: userData
            })
            dispatch({
                type: SET_USER,
                payload: userData
            })
            
        })
    } catch (error) {
        console.log(error)
        //return alert("Credenciales no válidas")
    }
}


export const logout = () => async dispatch => {
    await axios.post(`${LOGIN}/logout`)
        .then(res => {
            dispatch({
                type: LOGOUT,
                payload: res.data
            })
        })

}